import styled from 'styled-components'
import { Select, Divider } from 'antd'

export const CharacterSelect = styled(Select)`
  width: 100%;

  .ant-select-selector {
    padding: 10px 12px !important;
  }
`

export const SectionDivider = styled(Divider)<{ empty?: boolean }>`
  font-family: HonestMaria;

  > span {
    font-size: 28px;
    color: ${(props) => (props.empty ? 'darkred' : 'black')};
  }
`
